import { render, staticRenderFns } from "./FpTreeItem.vue?vue&type=template&id=01f8875a&lang=pug&"
import script from "./FpTreeItem.vue?vue&type=script&lang=js&"
export * from "./FpTreeItem.vue?vue&type=script&lang=js&"
import style0 from "./FpTreeItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports